module.exports = __webpack_public_path__ + "img/nt1-11-75-1.prt.c3a01f92.jpg";